import { render, staticRenderFns } from "./ModuleSwitcherComponent.vue?vue&type=template&id=db2c7b20&scoped=true"
import script from "./ModuleSwitcherComponent.vue?vue&type=script&lang=js"
export * from "./ModuleSwitcherComponent.vue?vue&type=script&lang=js"
import style0 from "./ModuleSwitcherComponent.vue?vue&type=style&index=0&id=db2c7b20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2c7b20",
  null
  
)

export default component.exports